var _process_env_ENABLE_DATA_TRACKING, _process_env_ENABLE_PERFORMANCE_TRACKING, _process_env_FILE_STORAGE_URL, _process_env_GTM_KEY, _process_env_IS_ERROR_BOUNDARY_ENABLED, _process_env_IS_RESUME_COPILOT_FEATURE_ENABLED, _process_env_MIXPANEL_TOKEN, _process_env_LINKEDIN_CLIENT_ID, _process_env_ROLLBAR_ACCESS_TOKEN, _process_env_ROLLBAR_ENABLED, _process_env_ROLLBAR_ENVIRONMENT;
export var commonDevEnv = {
    AUTH_API_URL: process.env.AUTH_API_URL ? process.env.AUTH_API_URL : 'https://localhost:44321',
    ENABLE_DATA_TRACKING: (_process_env_ENABLE_DATA_TRACKING = process.env.ENABLE_DATA_TRACKING) !== null && _process_env_ENABLE_DATA_TRACKING !== void 0 ? _process_env_ENABLE_DATA_TRACKING : 'false',
    ENABLE_PERFORMANCE_TRACKING: (_process_env_ENABLE_PERFORMANCE_TRACKING = process.env.ENABLE_PERFORMANCE_TRACKING) !== null && _process_env_ENABLE_PERFORMANCE_TRACKING !== void 0 ? _process_env_ENABLE_PERFORMANCE_TRACKING : 'false',
    FBO_API_URL: process.env.FBO_API_URL ? process.env.FBO_API_URL : 'https://qa.flexbackoffice.com/api/api',
    FBO_PERFORMANCE_URL: process.env.FBO_PERFORMANCE_URL ? process.env.FBO_PERFORMANCE_URL : 'https://fbo-performance-qa.azurewebsites.net',
    FBO_WEB_URL: process.env.FBO_WEB_URL ? process.env.FBO_WEB_URL : 'https://qa.flexbackoffice.com',
    FILE_STORAGE_URL: (_process_env_FILE_STORAGE_URL = process.env.FILE_STORAGE_URL) !== null && _process_env_FILE_STORAGE_URL !== void 0 ? _process_env_FILE_STORAGE_URL : 'https://procomfileservicedev.blob.core.windows.net/filestorage',
    GTM_KEY: (_process_env_GTM_KEY = process.env.GTM_KEY) !== null && _process_env_GTM_KEY !== void 0 ? _process_env_GTM_KEY : 'GTM-5JVF36B',
    GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY ? process.env.GOOGLE_MAPS_API_KEY : 'AIzaSyCfSytBelPmnp5BqJ0S3nQ1uuPq8y9cqg8',
    IS_ERROR_BOUNDARY_ENABLED: (_process_env_IS_ERROR_BOUNDARY_ENABLED = process.env.IS_ERROR_BOUNDARY_ENABLED) !== null && _process_env_IS_ERROR_BOUNDARY_ENABLED !== void 0 ? _process_env_IS_ERROR_BOUNDARY_ENABLED : 'false',
    IS_RESUME_COPILOT_FEATURE_ENABLED: (_process_env_IS_RESUME_COPILOT_FEATURE_ENABLED = process.env.IS_RESUME_COPILOT_FEATURE_ENABLED) !== null && _process_env_IS_RESUME_COPILOT_FEATURE_ENABLED !== void 0 ? _process_env_IS_RESUME_COPILOT_FEATURE_ENABLED : 'false',
    JOB_API_URL: process.env.JOB_API_URL ? process.env.JOB_API_URL : 'https://localhost:44335',
    MIXPANEL_TOKEN: (_process_env_MIXPANEL_TOKEN = process.env.MIXPANEL_TOKEN) !== null && _process_env_MIXPANEL_TOKEN !== void 0 ? _process_env_MIXPANEL_TOKEN : '',
    ONBOARDING_API_URL: process.env.ONBOARDING_API_URL ? process.env.ONBOARDING_API_URL : 'https://localhost:44325',
    PANDA_DOC_WEB_URL: process.env.PANDA_DOC_WEB_URL ? process.env.PANDA_DOC_WEB_URL : 'https://app.pandadoc.com',
    SYNC_FUSION_EDITOR_KEY: process.env.SYNC_FUSION_EDITOR_KEY ? process.env.SYNC_FUSION_EDITOR_KEY : '',
    SYNC_FUSION_EDITOR_SERVICE_URL: process.env.SYNC_FUSION_EDITOR_SERVICE_URL ? process.env.SYNC_FUSION_EDITOR_SERVICE_URL : '',
    TALENT_POOL_API_URL: process.env.TALENT_POOL_API_URL ? process.env.TALENT_POOL_API_URL : 'https://localhost:7251',
    TINY_MCE_API_KEY: process.env.TINY_MCE_API_KEY ? process.env.TINY_MCE_API_KEY : 'r2glkki6lkrhkd3rc4stsd3rgiiglvddl17zl1epw1cnha7q',
    cognito: {
        AWS_CLIENT_ID: '65mgo09b2ps7km60f3300t4bal',
        AWS_USERPOOL_ID: 'ca-central-1_G7zoQLSzQ',
        AWS_AUTH_URL: process.env.AWS_AUTH_URL ? process.env.AWS_AUTH_URL : 'https://demo.auth.ca-central-1.amazoncognito.com'
    },
    LINKEDIN: {
        CLIENT_ID: (_process_env_LINKEDIN_CLIENT_ID = process.env.LINKEDIN_CLIENT_ID) !== null && _process_env_LINKEDIN_CLIENT_ID !== void 0 ? _process_env_LINKEDIN_CLIENT_ID : '',
        AUTH_URL: 'https://www.linkedin.com/oauth/v2'
    },
    rollbar: {
        captureUncaught: process.env.ROLLBAR_CAPTURE_UNCAUGHT ? process.env.ROLLBAR_CAPTURE_UNCAUGHT === 'true' : false,
        captureUnhandledRejections: process.env.ROLLBAR_CAPTURE_UNHANDLED ? process.env.ROLLBAR_CAPTURE_UNHANDLED === 'true' : false,
        accessToken: (_process_env_ROLLBAR_ACCESS_TOKEN = process.env.ROLLBAR_ACCESS_TOKEN) !== null && _process_env_ROLLBAR_ACCESS_TOKEN !== void 0 ? _process_env_ROLLBAR_ACCESS_TOKEN : '123',
        enabled: (_process_env_ROLLBAR_ENABLED = process.env.ROLLBAR_ENABLED) !== null && _process_env_ROLLBAR_ENABLED !== void 0 ? _process_env_ROLLBAR_ENABLED : 'false',
        payload: {
            environment: (_process_env_ROLLBAR_ENVIRONMENT = process.env.ROLLBAR_ENVIRONMENT) !== null && _process_env_ROLLBAR_ENVIRONMENT !== void 0 ? _process_env_ROLLBAR_ENVIRONMENT : 'local'
        }
    }
};
export var commonCiEnv = {
    AUTH_API_URL: '#{AUTH_API_URL}#',
    ENABLE_DATA_TRACKING: '#{ENABLE_DATA_TRACKING}#',
    ENABLE_PERFORMANCE_TRACKING: '#{ENABLE_PERFORMANCE_TRACKING}#',
    FBO_API_URL: '#{FBO_API_URL}#',
    FBO_PERFORMANCE_URL: '#{FBO_PERFORMANCE_URL}#',
    FBO_WEB_URL: '#{FBO_WEB_URL}#',
    FILE_STORAGE_URL: '#{FILE_STORAGE_URL}#',
    GOOGLE_MAPS_API_KEY: '#{GOOGLE_MAPS_API_KEY}#',
    GTM_KEY: '#{GTM_KEY}#',
    IS_ERROR_BOUNDARY_ENABLED: '#{IS_ERROR_BOUNDARY_ENABLED}',
    IS_RESUME_COPILOT_FEATURE_ENABLED: '#{IS_RESUME_COPILOT_FEATURE_ENABLED}#',
    JOB_API_URL: '#{JOB_API_URL}#',
    MIXPANEL_TOKEN: '#{MIXPANEL_TOKEN}#',
    ONBOARDING_API_URL: '#{ONBOARDING_API_URL}#',
    PANDA_DOC_WEB_URL: '#{PANDA_DOC_WEB_URL}#',
    SYNC_FUSION_EDITOR_KEY: '#{SYNC_FUSION_EDITOR_KEY}#',
    SYNC_FUSION_EDITOR_SERVICE_URL: '#{SYNC_FUSION_EDITOR_SERVICE_URL}#',
    TALENT_POOL_API_URL: '#{TALENT_POOL_API_URL}#',
    TINY_MCE_API_KEY: '#{TINY_MCE_API_KEY}#',
    cognito: {
        AWS_CLIENT_ID: '#{AWS_CLIENT_ID}#',
        AWS_USERPOOL_ID: '#{AWS_USERPOOL_ID}#',
        AWS_AUTH_URL: '#{AWS_AUTH_URL}#'
    },
    LINKEDIN: {
        CLIENT_ID: '#{LINKEDIN_CLIENT_ID}#',
        AUTH_URL: '#{LINKEDIN_AUTH_URL}#'
    },
    rollbar: {
        accessToken: '#{Rollbar.FrontEndAccessToken}#',
        captureUncaught: true,
        captureUnhandledRejections: true,
        enabled: '#{Rollbar.FrontEndEnabled}#',
        payload: {
            environment: '#{Rollbar.Environment}#'
        }
    }
};
